import { render, staticRenderFns } from "./meal-ratings.vue?vue&type=template&id=65dbfe41"
import script from "./meal-ratings.vue?vue&type=script&lang=js"
export * from "./meal-ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports